<template>
  
    <div class="">
     
      <div class="w-full max-w-sm h-auto p-4 bg-white rounded-xl shadow-md flex flex-col justify-start items-start gap-4 overflow-hidden">
  <div class="w-full h-auto flex flex-col justify-start items-start gap-2">

  
      <div class="text-[#403b38] text-base font-bold font-['Outfit'] leading-normal tracking-wide">{{ title }}</div>

      <div class="text-[#403b38] text-sm font-normal font-['Outfit'] leading-tight">{{ description }}</div>
      <br>
      <ul class="w-full flex flex-wrap gap-2">
        <div class="flex-col justify-start items-start gap-2 flex">
        <!-- Loop through actions and open dialog on click -->
        <li 
          v-for="(item, index) in actions" 
          :key="index" 
          class="flex items-center text-pink-500 cursor-pointer" 
          @click="openDialog(index)"
        >
        <div class="px-4 py-2 bg-[#fbeae6] rounded-3xl justify-start items-center gap-2 inline-flex">
      <div class="text-[#ed6e4e] text-sm font-normal font-['Outfit'] leading-tight">{{ item.title }}</div>
    </div>
        
        </li></div>
      </ul></div></div>
  
      <!-- Dialog Box -->
      <div v-if="isDialogOpen" class="fixed inset-0   bg-opacity-50 flex items-center justify-center">
        <div class="dialog-container bg-[#e2d9d7]  rounded-lg p-6">
          <!-- Close Button -->
          <button @click="closeDialog" class="text-gray-400 float-right">X</button>
          
          <h3 class="text-[#403b38] text-base font-bold font-['Outfit'] leading-normal tracking-wide mb-4">{{ actions[activeIndex].title }}</h3>
          
          <!-- Tabs -->
          <div class="flex border-b border-gray-700 mb-4">
            <span 
              v-for="(tab, i) in actions[activeIndex].tabs" 
              :key="i" 
              @click="activeTab = i" 
              :class="{'text-[#ed6e4e]': activeTab === i, 'text-[#403b38]': activeTab !== i}" 
              class="cursor-pointer px-4 py-2"
            >
              {{ tab.title }}
            </span>
          </div>
  
          <!-- Tab Content -->
          <div class="dialog-content relative">

            <!-- YES this is ugly. We're looking by tab name to see which tab you're on. If you're not on the realtime data tab, show the code snippers -->
            <div v-if="actions[activeIndex].title != 'See real-time sample data'">
                <!-- Copy Icon -->
                <button @click="copyToClipboard" class="absolute top-2 right-2 text-gray-400 hover:text-white">
                    <i class="fas fa-copy"></i> <!-- Font Awesome copy icon -->
                  </button>

                <pre><code v-html="actions[activeIndex].tabs[activeTab].content" ref="codeText"></code><!-- Optional Confirmation Message -->
                 
                  <span v-if="copied" class="absolute top-2 right-12 text-green-400 text-xs">Copied!</span></pre>
                  <br><div class="text-[#403b38] text-sm font-normal font-['Outfit'] leading-tight">To utilize this data in your own application, use the connection details specified above, and examine the sample code snippets to leverage in your application.</div>
            </div>
            <div v-if="actions[activeIndex].title === 'See real-time sample data' && activeTab === 0">
                <div class="text-gray-300">
                <p>Real-time Data:</p>
                
                <table border="1">
                  <tbody>
                    <tr v-for="(row, rowIndex) in tableData" :key="rowIndex">
                      <td v-for="(cell, colIndex) in row" :key="colIndex">
                        <div v-if="cell" class="h-[53px] p-1 bg-white rounded-lg border border-[#999999] justify-start items-center gap-2">
                    <div class="grow shrink basis-0 text-center text-[#403b38] text-[10px] font-normal font-['Fira Code'] leading-[15px]">{{ truncateText(cell, 100) }}</div>
                  </div> 
                      </td>
                    </tr>
                  </tbody>
                </table>
                <p v-if="error" class="error">{{ error }}</p>
            </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "DialogCard",
    props: {
      title: String,
      description: String,
      actions: Array, // Expecting each action to have `title`, and an array of `tabs` with `title` and `content`
      websocket_url: String
    },
    data() {
      return {
        isDialogOpen: false,
        activeIndex: null, // Track the index of the action being viewed
        activeTab: 0, // Track the active tab within the dialog
       
        intervalId: null, // Interval ID for clearing
        copied: false, // State for showing "Copied!" confirmation
        messages: [], // Array to store incoming messages
        websocket: null, // WebSocket instance
        error: null, // To capture any WebSocket errors
        tableData: Array(4).fill(null).map(() => Array(3).fill(null)), // 4 rows x 3 columns
        currentCellIndex: 0 // Tracks the current cell index being updated
        
      };
    },
    methods: {
      openDialog(index) {
        this.activeIndex = index;
        this.activeTab = 0; // Reset to the first tab each time
        this.isDialogOpen = true;
        
      },
      closeDialog() {
        this.isDialogOpen = false;
       
      },
     
    copyToClipboard() {
      // Select the code text from the ref
      const codeText = this.$refs.codeText.innerText;
      
      // Use Clipboard API to copy text
      navigator.clipboard.writeText(codeText).then(() => {
        // Show confirmation message
        this.copied = true;
        
        // Hide confirmation message after 1.5 seconds
        setTimeout(() => {
          this.copied = false;
        }, 1500);
      }).catch(err => {
        console.error("Failed to copy: ", err);
      });
    },

    connectWebSocket() {
      console.log("creating socket")
      // Create a WebSocket connection
      console.log("websocket url:" + this.websocket_url)
      this.websocket = new WebSocket(this.websocket_url);

    
      // Listen for messages
      this.websocket.onmessage = async (event) => {
     
        let newMessage;
        if (event.data instanceof Blob) {
          // Convert Blob to text
          const text = await event.data.text();
          newMessage = text
        } else {
          // If not a Blob, assume it's a string
          newMessage = event.data;
        }
        // Update the table
       this.updateTable(newMessage);

       // console.log(this.messages)
         // Use reactivity-safe array update
         //this.messages = [...this.messages, newMessage];
      };

      // Handle errors
      this.websocket.onerror = (event) => {
        this.error = "WebSocket error occurred.";
        console.error("WebSocket error:", event);
      };

      // Handle connection close
      this.websocket.onclose = (event) => {
        console.log("WebSocket closed:", event);
      };
    },
    updateTable(newMessage) {
      // Calculate the row and column based on the current cell index
      const totalColumns = 3;
      const totalCells = 4 * totalColumns;
      const row = Math.floor(this.currentCellIndex / totalColumns);
      const col = this.currentCellIndex % totalColumns;

      // Update the cell in the table (reactive in Vue 3)
      this.tableData[row][col] = newMessage;

      // Increment the cell index
      this.currentCellIndex++;

      // If the table is full, reset it
      if (this.currentCellIndex >= totalCells) {
        this.resetTable();
      }
    },
    resetTable() {
      this.tableData = Array(4).fill(null).map(() => Array(3).fill(null)); // Reset the table
      this.currentCellIndex = 0; // Reset the cell index
    },
    truncateText(text, maxLength) {
      if (!text) return "-";
      return text.length > maxLength ? text.substring(0, maxLength) + "..." : text;
    },
    },
    
 
  mounted() {
    this.connectWebSocket(); // Connect to WebSocket on component mount
  },
  beforeUnmount() {
    console.log("unmount")
    if (this.websocket) {
      this.websocket.close(); // Close WebSocket connection on component destroy
    }
  },
  };
  </script>
  
  <style scoped>

  /* Styling for fixed-size dialog */
.dialog-container {
  width: 800px; /* Fixed width */
  height: 600px; /* Fixed height */
  overflow-y: auto; /* Add scrolling for overflowing content */
  overflow-x: hidden; /* Disable horizontal scrolling */
  z-index: 999;
}

.dialog-content {
  max-height: calc(100% - 80px); /* Adjust height based on padding and header */
  overflow-y: auto; /* Add scroll only to the content if needed */
}


/* Basic styling for code blocks */
pre {
  background-color: #121212; /* Dark background */
  padding: 1rem;
  border-radius: 8px;
  overflow-x: auto;
  color: #e2e8f0; /* Light text */
  font-size: 0.875rem; /* Slightly smaller font */
  line-height: 1.5;
}

code {
  font-family: "Source Code Pro", monospace; /* Use a monospace font */
  color: #63b3ed; /* Optional: Custom color for code text */
}

button i {
  font-size: 1rem;
}

table {
  width: 100%;
  border-collapse: separate; /* Use 'separate' for border-spacing to work */
  border-spacing: 10px; /* Add space between cells */
  text-align: center;
  table-layout: fixed; /* Enforce consistent column widths */
}
td {
  width: 33%; /* Each column takes up one-third of the table width */
  height: 50px; /* Set a fixed height for the rows */
  padding: 10px; /* Add inner space around the content in each cell */
  text-align: center;
  vertical-align: middle; /* Align text vertically */
  word-wrap: break-word; /* Allow text to wrap within the cell */
  overflow: hidden; /* Ensure overflowing text stays inside the cell */
  font-size: 9px;
  border: 0px solid #ccc; /* Optional: Add a border for better visibility */
}
.error {
  color: red;
  font-weight: bold;
}
  </style>
  